module.exports = __webpack_public_path__ + "img/A7.a91ac43a.svg";